<template>
  <v-app :dark="isDarkMode" class="app">
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" })
  }
}
</script>
<style lang="scss" scoped>
.app {
  max-width: $desktop-width;
  margin: auto;
}
</style>
